import { API_BASE_URL } from "../config/apiBase";
import { getAuthUserHeader } from "./userRoles";

/** Download through fetch so Student View identity stays attached to the request. */
export async function downloadStudentCertificate(studentId) {
  const response = await fetch(
    `${API_BASE_URL}/api/students/${encodeURIComponent(studentId)}/certificate?download=true`,
    { headers: { "X-User": getAuthUserHeader() }, cache: "no-store" }
  );
  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    throw new Error(payload?.detail || "We could not prepare your certificate. Please try again.");
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `HIRI-certificate-${studentId}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
